import _ from 'lodash';
import api from '../../api';
import * as types from '../mutation-types';

const state = {
  items: {},
};

const getters = {
  getRakutenItemByItemCode: s => itemCode => _.get(s, ['items', itemCode]),
};

const actions = {
  fetchRakutenItem({ commit }, itemCode) {
    return api.rakuten.getItem(itemCode).then(({ data: response }) => {
      commit(types.RECEIVE_RAKUTEN_ITEM, response);
    });
  },
};

/* eslint no-param-reassign: 0, no-shadow: 0 */
const mutations = {
  [types.RECEIVE_RAKUTEN_ITEM](s, data) {
    const { itemCode } = data;
    s.items[itemCode] = data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
